import $ from 'jquery';
import slick from 'slick-carousel';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class Testimonial {
    constructor(target, settings) {

    }

    init() {
        this.testimonialSlider();
    }

    testimonialSlider() {
        let $slickElement = $('.testimonial-list');

        if ($slickElement.length > 0) {
            let $testimonialListClasses = $slickElement.closest('section').attr('class').trim();
            if (!$testimonialListClasses) {
                $slickElement.addClass('no-background');
            }

            $slickElement.on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
                if (currentSlide === undefined) {
                    currentSlide = 0;
                }

                $('.js-count').text(`${currentSlide + 1} of ${slick.slideCount}`);
            });

            if ($('.testimonial-list').length) {
                $('.testimonial-list').slick({
                    mobileFirst: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    arrows: true,
                    adaptiveHeight: false
                });
            }
        }
    }
}

export default Testimonial;

$(() => {
	const testimonial = new Testimonial();
	testimonial.init();
});